var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TheTopNav'),_c('div',{class:{
			'main-header-workflow': true,
			expanded: !_vm.sidebarMenuCollapsed,
			details: _vm.isExecutionPage || _vm.isHistoryVersionPage,
			version: _vm.isHistoryVersionPage, executions: _vm.isExecutionPage,
		}},[_c('div',{staticClass:"top-menu"},[(!_vm.isExecutionPage || (_vm.isExecutionPage && _vm.hasPrevPage))?_c('button',{staticClass:"button-back",on:{"click":function($event){return _vm.backPage()}}},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/left-gray.svg")}})]):_vm._e(),(_vm.isExecutionPage)?_c('ExecutionDetails'):(_vm.isHistoryVersionPage)?_c('VersionHistoryDetails'):_c('WorkflowDetails')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }